module.exports = __webpack_public_path__ + "img/step-4.d397f21.jpg";